import { useEffect } from 'react';

export default function useTargetSectionNavigation({
  targetSection,
  sections,
  pageRefs,
  setCurrentPage,
  isProgrammaticScrollRef,
}) {
  useEffect(() => {
    if (!targetSection || !sections || sections.length === 0) return;

    console.log('🎯 Navigating to targetSection:', targetSection);
    console.log('🎯 Available sections:', sections.map((s) => ({ title: s.title, page: s.pageNumber })));

    const matches = sections.filter((s) =>
      s.title === targetSection ||
      s.title.includes(targetSection) ||
      targetSection.includes(s.title)
    );

    matches.sort((a, b) => {
      if (a.title === targetSection) return -1;
      if (b.title === targetSection) return 1;
      return b.title.length - a.title.length;
    });

    const section = matches[0];

    if (section) {
      console.log('✅ Found matching section:', section.title, 'Page:', section.pageNumber);

      isProgrammaticScrollRef.current = true;
      setCurrentPage(section.pageNumber);

      setTimeout(() => {
        const pageContainer = pageRefs.current[section.pageNumber];
        if (pageContainer) {
          console.log('📜 Scrolling to page container:', section.pageNumber);
          pageContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });

          setTimeout(() => {
            isProgrammaticScrollRef.current = false;
            console.log('✅ Programmatic scroll complete, re-enabling scroll updates');
          }, 1000);
        } else {
          console.warn('⚠️ Page container not found for page:', section.pageNumber);
          isProgrammaticScrollRef.current = false;
        }
      }, 300);
    } else {
      console.warn('⚠️ No matching section found for:', targetSection);
    }
  }, [targetSection, sections, pageRefs, setCurrentPage, isProgrammaticScrollRef]);
}
